import {
	useTopicPagePaginatedRecentPetitionsData,
	useTopicPagePaginatedTrendingPetitionsData,
} from 'src/app/pages/topic/pageContext';

type Result = ModelHookResult<{
	indexed: boolean;
}>;

export function useMetaRobots(): Result {
	const {
		data: { totalCount: recentPetitionsCount },
	} = useTopicPagePaginatedRecentPetitionsData();

	const {
		data: { totalCount: trendingPetitionsCount },
	} = useTopicPagePaginatedTrendingPetitionsData();

	return {
		data: {
			// TODO Update when third petition list is added
			indexed: !!(recentPetitionsCount || trendingPetitionsCount),
		},
	};
}
